import { getRegs, selectValues } from '../../../utils/fc'
import { dateInYear, resolveCcIdFromItemOuRubr } from './budgetDashboardHelpers'

const dotAnualFields = {
  orcDotAnual_id: 'orcDotAnual_id',
  orcItem_id: 'orcItem_id',
  orcDotAnual_vlrIni: 'orcDotAnual_vlrIni',
  orcDotAnual_vlrAtu: 'orcDotAnual_vlrAtu',
  '(SELECT nivel2_id FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'cc_id',
  '(SELECT nivel2 FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'cc_nome',
  '(SELECT item_orcamentario FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'item_label',
  '(SELECT nivel3_id FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'nivel3_id',
  '(SELECT nivel3 FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'nivel3',
  '(SELECT nivel4 FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'nivel4',
  '(SELECT id_oikos FROM viewRubr_OrcItem WHERE orcItem_id = orcDotAnual.orcItem_id LIMIT 1)': 'subrubrica_id',
}

const orcDotFields = {
  orcItem_id: 'orcItem_id',
  orcDot_valor: 'orcDot_valor',
  orcDot_data: 'orcDot_data',
  '(SELECT nivel2_id FROM viewRubr_OrcItem WHERE orcItem_id = orcDot.orcItem_id LIMIT 1)': 'cc_id',
}

const eventoFields = {
  contrFornEvento_id: 'contrFornEvento_id',
  contrForn_id: 'contrForn_id',
  contrFornEvento_num: 'contrFornEvento_num',
  contrFornEvento_desc: 'contrFornEvento_desc',
  contrFornEvento_vlr: 'contrFornEvento_vlr',
  contrFornEvento_dtPrev: 'contrFornEvento_dtPrev',
  contrFornEvento_pgtoPrazoDias: 'contrFornEvento_pgtoPrazoDias',
  contrFornEvento_aprovLiberado: 'contrFornEvento_aprovLiberado',
  bdro_id: 'bdro_id',
  '(SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id AND contrForn.contrForn_ativo = 1 LIMIT 1)': 'orcItem_id',
  '(SELECT vroi.nivel2_id FROM viewRubr_OrcItem vroi INNER JOIN contrForn cf ON cf.orcItem_id = vroi.orcItem_id WHERE cf.contrForn_id = contrFornEvento.contrForn_id AND cf.contrForn_ativo = 1 LIMIT 1)': 'cc_id',
  '(SELECT contrForn_ativo FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_ativo',
  '(SELECT contrForn_num FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_num',
  '(SELECT contrForn_desc FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_desc',
  '(SELECT contrFornStatus_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrFornStatus_id',
  '(SELECT contrFornTp_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrFornTp_id',
  '(SELECT contrForn_parteTab FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_parteTab',
  '(SELECT contrForn_parteId FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_parteId',
  '(SELECT CASE WHEN contrForn.contrForn_parteTab = "pf" THEN (SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = contrForn.contrForn_parteId LIMIT 1) ELSE (SELECT pj_razaosocial FROM pj WHERE pj.pj_id = contrForn.contrForn_parteId LIMIT 1) END FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'fornecedor_nome',
  '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1) LIMIT 1)': 'orcItem_desc',
  '(SELECT nivel3 FROM viewRubr_OrcItem WHERE orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1) LIMIT 1)': 'rubrica_nome',
  '(SELECT bdro_dtVenc FROM bdro WHERE bdro.bdro_tabRef = "contrFornEvento" AND bdro.bdro_tabId = contrFornEvento.contrFornEvento_id AND bdro.bdro_ativo = 1 ORDER BY bdro.bdro_id DESC LIMIT 1)': 'bdro_dtVenc',
  '(SELECT bdro_dtQuit FROM bdro WHERE bdro.bdro_tabRef = "contrFornEvento" AND bdro.bdro_tabId = contrFornEvento.contrFornEvento_id AND bdro.bdro_ativo = 1 ORDER BY bdro.bdro_id DESC LIMIT 1)': 'bdro_dtQuit',
}

const orcItemTaxonomyFields = {
  orcItem_id: 'orcItem_id',
  item_orcamentario: 'item_label',
  orcItem_desc: 'orcItem_desc',
  nivel2_id: 'nivel2_id',
  nivel2: 'nivel2',
  nivel3_id: 'nivel3_id',
  nivel3: 'nivel3',
  nivel4: 'nivel4',
  id_oikos: 'subrubrica_id',
  rubrica: 'rubrica',
}

const bdroFields = {
  bdro_vlr: 'bdro_vlr',
  bdro_dtVenc: 'bdro_dtVenc',
  orcItem_id: 'orcItem_id',
  orcRubr_id: 'orcRubr_id',
  '(SELECT nivel2_id FROM viewRubr_OrcItem WHERE orcItem_id = bdro.orcItem_id LIMIT 1)': 'cc_id_item',
  '(SELECT nivel2_id FROM viewOrcRubr_taxonomia2 WHERE id_oikos = bdro.orcRubr_id LIMIT 1)': 'cc_id_rubr',
}

const movFields = {
  mov_vlr: 'mov_vlr',
  mov_dtQuit: 'mov_dtQuit',
  orcItem_id: 'orcItem_id',
  orcRubr_id: 'orcRubr_id',
  '(SELECT nivel2_id FROM viewRubr_OrcItem WHERE orcItem_id = mov.orcItem_id LIMIT 1)': 'cc_id_item',
  '(SELECT nivel2_id FROM viewOrcRubr_taxonomia2 WHERE id_oikos = mov.orcRubr_id LIMIT 1)': 'cc_id_rubr',
}

async function safeFetch(label, fn, fallback = []) {
  try {
    const result = await fn()
    return result ?? fallback
  } catch (err) {
    console.error(`[budget-dashboard] falha ao carregar ${label}:`, err?.data || err)
    return fallback
  }
}

function filterByAllowedCc(rows, ccIds, getCcId) {
  if (!ccIds || !ccIds.length) return rows || []
  const allowed = new Set(ccIds.map(Number))
  return (rows || []).filter(r => allowed.has(Number(getCcId(r))))
}

function inFilter(field, ids) {
  if (!ids?.length) return null
  return { [field]: `!IN!(${ids.join(',')})` }
}

export async function fetchCentrosDeCusto() {
  return safeFetch('centros de custo', async () => {
    const rows = await selectValues('orcRubr', 'orcRubr_id', 'orcRubr_nome', {
      orcRubr_ativo: 1,
      orcRubr_mae: '!IN!(1, 2)',
    })
    return (rows || []).sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
  }, [])
}

export async function fetchOrcCCustoByAno(ano, ccIds = null) {
  return safeFetch('orcCCusto', async () => {
    const data = { orcCCusto_ano: Number(ano) }
    if (ccIds && ccIds.length) {
      data.orcRubr_id = `!IN!(${ccIds.join(',')})`
    }
    const rows = await getRegs('orcCCusto', data, {
      orcCCusto_id: 'orcCCusto_id',
      orcRubr_id: 'orcRubr_id',
      orcCCusto_vlr: 'orcCCusto_vlr',
    })
    return rows || []
  }, [])
}

export async function fetchOrcDotAnualByAno(ano, ccIds = null) {
  return safeFetch('orcDotAnual', async () => {
    const rows = await getRegs('orcDotAnual', { orcDotAnual_ano: Number(ano) }, dotAnualFields)
    return filterByAllowedCc(rows, ccIds, r => r.cc_id)
  }, [])
}

export async function fetchOrcDotByAno(ano, ccIds = null, orcItemIds = null) {
  if (!orcItemIds?.length) return []
  return safeFetch('orcDot', async () => {
    const data = {
      ...inFilter('orcItem_id', orcItemIds),
    }
    const rows = await getRegs('orcDot', data, orcDotFields)
    const noAno = (rows || []).filter(r => dateInYear(r.orcDot_data, ano))
    return filterByAllowedCc(noAno, ccIds, r => r.cc_id)
  }, [])
}

export async function fetchContrFornEventosByAno(ano, ccIds = null, orcItemIds = null) {
  if (!orcItemIds?.length) return []
  return safeFetch('contrFornEvento', async () => {
    const data = {
      contrForn_id: `!IN!(SELECT contrForn_id FROM contrForn WHERE contrForn_ativo = 1 AND orcItem_id IN (${orcItemIds.join(',')}))`,
    }
    const rows = await getRegs('contrFornEvento', data, eventoFields)
    return filterByAllowedCc(rows, ccIds, r => r.cc_id)
  }, [])
}

export async function fetchBdroByAno(ano, ccIds = null, orcItemIds = null) {
  if (!orcItemIds?.length) return []
  return safeFetch('bdro', async () => {
    const data = {
      ...inFilter('orcItem_id', orcItemIds),
    }
    const rows = await getRegs('bdro', data, bdroFields)
    const noAno = (rows || []).filter(r => dateInYear(r.bdro_dtVenc, ano))
    return filterByAllowedCc(noAno, ccIds, r => resolveCcIdFromItemOuRubr(r))
  }, [])
}

export async function fetchMovByAno(ano, ccIds = null, orcItemIds = null) {
  if (!orcItemIds?.length) return []
  return safeFetch('mov', async () => {
    const data = {
      ...inFilter('orcItem_id', orcItemIds),
    }
    const rows = await getRegs('mov', data, movFields)
    const noAno = (rows || []).filter(r => dateInYear(r.mov_dtQuit, ano))
    return filterByAllowedCc(noAno, ccIds, r => resolveCcIdFromItemOuRubr(r))
  }, [])
}

export async function fetchOrcItemsTaxonomy(orcItemIds = null) {
  if (!orcItemIds?.length) return []
  return safeFetch('viewRubr_OrcItem', async () => {
    const rows = await getRegs('viewRubr_OrcItem', {
      orcItem_id: `!IN!(${orcItemIds.join(',')})`,
    }, orcItemTaxonomyFields, false)
    return rows || []
  }, [])
}

export async function fetchGestorCcIds(pfId) {
  if (!pfId) return []

  return safeFetch('gestor CCs', async () => {
    const equipe = await getRegs('projEquipe', { pf_id: pfId, projAtuacao_id: 8 }) || []
    if (!equipe.length) return []

    const projIds = [...new Set(equipe.map(e => e.proj_id).filter(Boolean))]
    if (!projIds.length) return []

    const projs = await getRegs('proj', { proj_id: `!IN!(${projIds.join(',')})` }, { orcRubr_id: 'orcRubr_id' }) || []
    const nivel3Ids = [...new Set(projs.map(p => Number(p.orcRubr_id)).filter(Boolean))]
    if (!nivel3Ids.length) return []

    const taxRows = await getRegs('viewOrcRubr_taxonomia2', { nivel3_id: `!IN!(${nivel3Ids.join(',')})` }, {
      nivel2_id: 'nivel2_id',
    }) || []

    return [...new Set(taxRows.map(r => Number(r.nivel2_id)).filter(Boolean))]
  }, [])
}

export async function fetchContrFornByOrcItemIds(orcItemIds = null) {
  if (!orcItemIds?.length) return []
  return safeFetch('contrForn', async () => {
    const rows = await getRegs('contrForn', {
      orcItem_id: `!IN!(${orcItemIds.join(',')})`,
      contrForn_ativo: 1,
    }, {
      contrForn_id: 'contrForn_id',
      orcItem_id: 'orcItem_id',
    }, false)
    return rows || []
  }, [])
}

export async function loadBudgetDashboardData({ ano, allowedCcIds }) {
  const ccFilter = allowedCcIds == null ? null : allowedCcIds

  const [centros, orcCCustoRows, dotAnualRows] = await Promise.all([
    fetchCentrosDeCusto(),
    fetchOrcCCustoByAno(ano, ccFilter),
    fetchOrcDotAnualByAno(ano, ccFilter),
  ])

  const orcItemIds = [...new Set(
    (dotAnualRows || []).map(r => Number(r.orcItem_id)).filter(Boolean),
  )]

  const [orcDotRows, eventoRows, bdroRows, movRows, taxonomyRows, contrFornRows] = await Promise.all([
    fetchOrcDotByAno(ano, ccFilter, orcItemIds),
    fetchContrFornEventosByAno(ano, ccFilter, orcItemIds),
    fetchBdroByAno(ano, ccFilter, orcItemIds),
    fetchMovByAno(ano, ccFilter, orcItemIds),
    fetchOrcItemsTaxonomy(orcItemIds),
    fetchContrFornByOrcItemIds(orcItemIds),
  ])

  const loadWarnings = []
  if (!dotAnualRows.length && orcItemIds.length === 0) {
    loadWarnings.push('orcDotAnual')
  }

  return {
    centros,
    orcCCustoRows,
    dotAnualRows,
    orcDotRows,
    eventoRows,
    bdroRows,
    movRows,
    taxonomyRows,
    contrFornRows,
    loadWarnings,
  }
}
